import { AxiosError, AxiosResponse } from 'axios';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import ICancelGfp from '~/@core/domain/filters/gfp/FilterCancelGfp';
import FilterCreateGfp from '~/@core/domain/filters/gfp/FilterCreateGfp';
import FilterGetGfpPrint from '~/@core/domain/filters/gfp/FilterGetGfpPrint';
import FilterGfpCarts from '~/@core/domain/filters/gfp/FilterGfpCarts';
import GfpCarts from '~/@core/domain/model/gfp/GfpCarts';
import IGfp from '~/@core/domain/model/gfp/IGfp';
import BeneficentCampaignGfp from '~/domain/model/BeneficentCampaignGfp/BeneficentCampaignGfp';
import { apiGfp } from '../config/index';

export const createGfp = (params: FilterCreateGfp) => {
  return new Promise<AxiosResponse<void>>((resolve, reject) => {
    apiGfp
      .post<void, AxiosResponse<void>>('/gfp', params)
      .then((response: AxiosResponse<void>) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};

export const fetchGfpCarts = (params: FilterGfpCarts) => {
  return new Promise<DefaultPaginated<GfpCarts[]>>((resolve, reject) => {
    apiGfp
      .get<void, AxiosResponse<DefaultPaginated<GfpCarts[]>>>('/gfp/carts', {
        params,
      })
      .then((response: AxiosResponse<DefaultPaginated<GfpCarts[]>>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};

export const fetchGfpPrint = (queryParams: FilterGetGfpPrint) => {
  return new Promise<IGfp[]>((resolve, reject) => {
    apiGfp
      .post<void, AxiosResponse<IGfp[]>>('/gfp/print', queryParams.gfpIds)
      .then((response: AxiosResponse<IGfp[]>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};

export const cancelGfp = (params: ICancelGfp) => {
  return new Promise<number[]>((resolve, reject) => {
    apiGfp
      .delete<void, AxiosResponse<number[]>>('/gfp/cancel', {
        data: params,
      })
      .then((response: AxiosResponse<number[]>) => {
        resolve(response.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};

export async function getAllCampaigns(commercialDate: string): Promise<BeneficentCampaignGfp[]> {
  const response = await apiGfp.get<BeneficentCampaignGfp[]>(
    `beneficent-campaign?commercialDate=${commercialDate}`,
  );
  return response.data;
}

export interface ExportCartColumns {
  status: boolean;
  car: boolean;
  gfpNumber: boolean;
  cce: boolean;
  type: boolean;
  generationDate: boolean;
  deliveryDate: boolean;
  commercialDate: boolean;
  client: boolean;
  product: boolean;
  productCode: boolean;
  quality: boolean;
  packaging: boolean;
  packagingDescription: boolean;
  qeQpe: boolean;
  gfpObs: boolean;
  multiGfp: boolean;
  printStatus: boolean;
}

export interface ExportCartParams {
  columns: ExportCartColumns;
  [key: string]: any;
}

interface ExportCartResponse {
  data: string;
}

export const exportCartToExcel = (params: ExportCartParams): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    apiGfp
      .post<ExportCartResponse>('/gfp/cart-export', params)
      .then(response => {
        resolve(response.data.data);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};
